<template>
  <Form
    url="/renovacoes/config/valor/licencas/update"
    v-if="!loader"
    :valor="valor"
  />
</template>

<script>
import Form from "./Form.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "app-config-renovacoes-valor-update",
  data() {
    return {
      valor: {},
      loader: true,
    };
  },
  components: {
    Form,
  },
  methods: {
    async getvalor(id) {
      try {
        const { data } = await this.$http.post(
          "/renovacoes/config/valor/licencas/find",
          {
            id,
          }
        );

        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const { id } = this.$route.params;

        const valor = await this.getvalor(id);

        if (!valor.id || valor == null) {
          return this.$toast.error("Registro não encontrado!");
        }

        this.valor = await valor;
        this.loader = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Configurações de Renovação",
      },
    ]);
    this.getInit();
  },
};
</script>
